import '@/css/app.css';
import { createApp } from 'vue';
import App from '@/App.vue';
import router from '@/router';
import { initializeTheme } from '@/composables/useAppearance';

// Initialize theme on startup
initializeTheme();

// Create and mount the Vue app
const app = createApp(App);

// Use router
app.use(router);

// Mount the app
app.mount('#app');
